import { noopReturn, isString } from '@motionone/utils';
function getUnitConverter(keyframes, definition) {
  var _a;
  var toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || noopReturn;
  var finalKeyframe = keyframes[keyframes.length - 1];
  if (isString(finalKeyframe)) {
    var unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
    if (unit) toUnit = function toUnit(value) {
      return value + unit;
    };
  }
  return toUnit;
}
export { getUnitConverter };